import { RouteLocationNormalized } from 'vue-router'

/**
 * Guard that blocks navigation if email is not verified
 * Redirects to home page with a message
 */
export const requireEmailVerification = async (to: RouteLocationNormalized, from: RouteLocationNormalized, store: any) => {
  if (!store.getters['users/getToken']) {
    return to
  }

  await store.dispatch('users/fetchUserRole')

  const emailConfirmed = store.getters['users/getEmailConfirmed']

  if (!emailConfirmed) {
    return { name: 'home' }
  }

  // Allow navigation if email is confirmed
  return undefined
}
